import { Close } from '@mui/icons-material';
import { DialogActions, Stack } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

export type ModalProps = Omit<DialogProps, 'title'> & {
  title: ReactNode;
  subTitle?: ReactNode;
  showCloseButton?: boolean;
  actions?: ReactNode;
};

export function Modal({
  title,
  subTitle,
  children,
  showCloseButton,
  actions,
  ...props
}: ModalProps) {
  return (
    <Backdrop open={props.open} className="z-50">
      <Dialog
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        {...props}
        classes={{
          paper: `p-6 pb-3 ${props.classes?.paper ?? ''}`,
        }}
      >
        <div className="flex flex-col gap-4">
          {showCloseButton && (
            <IconButton
              size="small"
              aria-label="close"
              onClick={event => props.onClose?.(event, 'escapeKeyDown')}
              className="w-4 h-4 ml-auto"
            >
              <Close className="w-4 h-4" />
            </IconButton>
          )}
          <Stack gap={1} id="modal-title">
            <DialogTitle variant="h2" id="modal-title" className="m-0">
              {title}
            </DialogTitle>
            {subTitle && (
              <Typography variant="subtitle1" color="text.secondary">
                {subTitle}
              </Typography>
            )}
          </Stack>
        </div>

        <DialogContent className="overflow-y-auto">{children}</DialogContent>
        {actions && (
          <DialogActions
            disableSpacing
            classes={{ root: '-mx-6 px-6 pt-3 flex gap-3 border-t' }}
          >
            {actions}
          </DialogActions>
        )}
      </Dialog>
    </Backdrop>
  );
}
